module.exports = __webpack_public_path__ + "static/img/auslaufschutz.21840499.svg";